import { createBrowserRouter, RouterProvider } from 'react-router';
import Login from './components/login/Login';
import { roleGuard } from './guards/AuthGuard';
import { LOGIN } from './services/constants/URIConstants';
import AdminStickLayout from './layout/AdminStickLayout';
import LendingDashboard from './components/dashboard/LendingDashboard';
import CustomerManagement from './components/customers/CustomerManagement';
import CustomerDebitsView from './components/customers/CustomerDebitsView';
import ReminderSystem from './components/reminders/ReminderSystem';
import CashflowDashboard from './components/admin/cashflow/CashflowDashboard';
import ReportsDashboard from './components/admin/reports/ReportsDashboard';
import HomeScreen from './components/home/HomeScreen';



export default function AppRoutes(props: any): React.ReactElement {
  const routes = createBrowserRouter([
    {
      path: '/',
      Component: HomeScreen,
    },
    { 
      path: 'admin',
      Component: AdminStickLayout,
      children: [
        {
          path: 'dashboard',
          Component: LendingDashboard,
          loader: roleGuard.protectedLoader,
        },
        {
          path: 'customers',
          Component: CustomerManagement,
          loader: roleGuard.protectedLoader,
        },
        {
          path: 'customers/:customerId/debits',
          Component: CustomerDebitsView,
          loader: roleGuard.protectedLoader,
        },
        {
          path: 'reminders',
          Component: ReminderSystem,
          loader: roleGuard.protectedLoader,
        },
        {
          path: 'cashflow',
          Component: CashflowDashboard,
          loader: roleGuard.protectedLoader,
        },
        {
          path: 'reports',
          Component: ReportsDashboard,
          loader: roleGuard.protectedLoader,
        },
      ],
    },
    {
      path: LOGIN,
      Component: Login
    },
    {
      path: '*',
      Component: HomeScreen,
    },
  ]);

  return <RouterProvider router={routes} />;
}
